import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, share } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private onSubject = new Subject<{ key: string, value: any }>();
  public changes = this.onSubject.asObservable().pipe(share());

  constructor(private router: Router) { }

  private start() {
    window.addEventListener("storage", this.StorageListener.bind(this));
  }

  private stop() {
    window.removeEventListener("storage", this.StorageListener.bind(this));
    this.onSubject.complete();
  }

  private StorageListener(event: StorageEvent) {
    if (event.storageArea == localStorage) {
      let v;

      try {
        v = JSON.parse(event.newValue!);
      } catch (e) {
        v = event.newValue;
      }

      this.onSubject.next({ key: event.key!, value: v });
    }

    if (event.storageArea == sessionStorage) {
      let v;

      try {
        v = JSON.parse(event.newValue!);
      } catch (e) {
        v = event.newValue;
      }

      this.onSubject.next({ key: event.key!, value: v });
    }
  }

  ngOnDestroy(): void {
    this.removeLocalUser();
    sessionStorage.clear();
    this.stop();
  }

  public storeUser(user: any) {
    localStorage.setItem('sysuser', JSON.stringify(user));
  }

  public storeData(key: string, data: any) {
    let current = localStorage.getItem(key);
    if (current)
      localStorage.removeItem(current);
    localStorage.setItem(key, JSON.stringify(data));
  }

  public getStoredDataByKey(key: string) {
    return JSON.parse(localStorage.getItem(key)!);
  }

  public removeLocalUser(){
    localStorage.removeItem('sysuser');
    this.router.navigate(["/login"]);
  }

  public getStoredUser(): any {
    return JSON.parse(localStorage.getItem('sysuser')!);
  }
}
